export const TITLE = 'Experience';
export const DESCRIPTION = 'Overview of your work experience';
export const DB_PREFIX = 'experience';
